import React from "react";
import { useSelector } from "react-redux";

import Dialog from "src/components/Dialog";
import ConfirmReturnDetails from "src/pages/RootDialogs/ReviewReturnsDialog/ConfirmReturnDetails";
import { getSaleById } from "src/store/sale/selector";

import type { Sale } from "src/interfaces/sale.interface";

function ConfirmReturnDetailsDialog({
  selectedUnreviewedReturnId,
  onGoToSale,
  onClose,
}: {
  onGoToSale?: (sale: Sale) => void;
  onClose: () => void;
  selectedUnreviewedReturnId?: string;
}) {
  const unreviewedReturn = useSelector((s: any) =>
    getSaleById(s, selectedUnreviewedReturnId)
  );
  return (
    <Dialog
      open={!!unreviewedReturn}
      onClose={onClose}
      scroll="body"
      fullWidth
      maxWidth="sm"
    >
      {!!unreviewedReturn && (
        <ConfirmReturnDetails
          onClose={onClose}
          unreviewedReturn={unreviewedReturn}
          onGoToSale={onGoToSale ? onGoToSale : onClose}
          onSave={onClose}
        />
      )}
    </Dialog>
  );
}

export default ConfirmReturnDetailsDialog;
